import script from "./ScheduleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleModal.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleModal.vue?vue&type=style&index=0&id=4873f698&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4873f698"]])

export default __exports__